<!--
@Time : 2020/11/30 6:21 上午
@Author : yekong
@File : jiankong2.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="paimingk">
      <div ref="myChart1" style="width: 520px;height: 400px"></div>
      <div ref="myChart2" style="width: 390px;height: 400px"></div>
      <div ref="myChart3" style="width: 390px;height: 400px"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "jiankong2",
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {
    drawLine() {
      var that = this;
      var barBottomColor = ["rgba(79, 199, 234, 1)", "rgba(79, 199, 234, 1)", "rgba(79, 199, 234, 1)", 'rgba(228, 109, 62, 1)'];
      var barTopColor = ["rgba(79, 199, 234, 1)", "rgba(79, 199, 234, 1)", "rgba(79, 199, 234, 1)", 'rgba(242, 163, 111, 1)'];
      var data = [[[4, 5, '上海'], [10, 6, '深圳'], [16, 9, '大连'], [20, 16, '北京']]];
      let myChart = this.$echarts.init(this.$refs.myChart1)
      myChart.setOption({
        title: {
          text: '企业开办',
          x: '250',
          y: 'top',
          textStyle: {
            //文字颜色
            color: 'rgba(57, 249, 255, 1)',
            //字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            //字体系列
            fontFamily: 'sans-serif',
            //字体大小
            fontSize: 30
          }
        },
        grid: {
          top: '13%',
          right: '0%',
          left: '20%',
          bottom: '19%'
        },
        xAxis: {
          axisTick: {
            show: false
          },
          min: 0,
          max: 24,
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 3
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            show: false,
            textStyle: {
              fontSize: 18,
              color: "rgba(255, 255, 255, 1)" //X轴文字颜色
            },
          },
          nameTextStyle: {
            fontSize: 30,
            padding: [70, 0, 0, -90]    // 四个数字分别为上右下左与原位置距离
          }
        },
        yAxis: {
          axisTick: {
            show: false
          },
          min: 0,
          max: 24,
          minInterval: 6,
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            show: true,
            scale: false,
            color: 'rgba(155, 173, 255, 1)',
            formatter: function (val) {
              return val + '小时';
            },
            textStyle: {
              fontSize: 24
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 3
            }
          },
          nameTextStyle: {
            fontSize: 30,
            padding: [0, 0, 0, 70]    // 四个数字分别为上右下左与原位置距离
          },
          scale: true
        },
        series: [{
          data: data[0],
          type: 'scatter',
          symbolSize: function () {
            return [60, 60];
          },
          label: {
            show: false,
            normal: {
              show: true,
              formatter: function (param) {
                return param.data[2];
              },
              fontSize:20,
              position: 'inside'
            }
          },
          itemStyle: {
            show: true,
            shadowBlur: 100,
            shadowOffsetY: 5,
            color: function (params) {
              return new that.$echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [{
                    offset: 1,
                    color: barTopColor[params.dataIndex]
                  },
                    {
                      offset: 0,
                      color: barBottomColor[params.dataIndex]
                    }
                  ]
              );
            },
            // color: function (params) {
            //   console.log(params.dataIndex)
            //   return that.$echarts.graphic.RadialGradient(
            //       0.4, 0.3, 1,
            //       [{
            //         offset: 0,
            //         color: colorList[params.dataIndex]
            //       },
            //         {
            //           offset: 1,
            //           color: colorList[params.dataIndex]
            //         }
            //       ]
            //   );
            // },
          }
        }]
      });
    },
    drawLine2() {
      var that = this;
      var barBottomColor = ["rgba(79, 199, 234, 1)", "rgba(79, 199, 234, 1)", "rgba(79, 199, 234, 1)", 'rgba(228, 109, 62, 1)'];
      var barTopColor = ["rgba(79, 199, 234, 1)", "rgba(79, 199, 234, 1)", "rgba(79, 199, 234, 1)", 'rgba(242, 163, 111, 1)'];
      var data = [[[4, 5, '上海'], [10, 6, '深圳'], [16, 9, '大连'], [20, 16, '北京']]];
      let myChart = this.$echarts.init(this.$refs.myChart2)
      myChart.setOption({
        title: {
          text: '刻制印章',
          x: '120',
          y: 'top',
          textStyle: {
            //文字颜色
            color: 'rgba(57, 249, 255, 1)',
            //字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            //字体系列
            fontFamily: 'sans-serif',
            //字体大小
            fontSize: 30
          }
        },
        grid: {
          top: '13%',
          right: '0%',
          left: '0%',
          bottom: '19%'
        },
        xAxis: {
          axisTick: {
            show: false
          },
          min: 0,
          max: 24,
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 3
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            show: false,
            textStyle: {
              fontSize: 18,
              color: "rgba(255, 255, 255, 1)" //X轴文字颜色
            },
          },
          nameTextStyle: {
            fontSize: 30,
            padding: [70, 0, 0, -90]    // 四个数字分别为上右下左与原位置距离
          }
        },
        yAxis: {
          axisTick: {
            show: false
          },
          min: 0,
          max: 24,
          minInterval: 6,
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            show: true,
            scale: false,
            color: 'rgba(155, 173, 255, 1)',
            formatter: function (val) {
              return val + '小时';
            },
            textStyle: {
              fontSize: 24
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 3
            }
          },
          nameTextStyle: {
            fontSize: 30,
            padding: [0, 0, 0, 70]    // 四个数字分别为上右下左与原位置距离
          },
          scale: true
        },
        series: [{
          data: data[0],
          type: 'scatter',
          symbolSize: function () {
            return [60, 60];
          },
          label: {
            show: false,
            normal: {
              show: true,
              formatter: function (param) {
                return param.data[2];
              },
              fontSize:20,
              position: 'inside'
            }
          },
          itemStyle: {
            show: true,
            shadowBlur: 100,
            shadowOffsetY: 5,
            color: function (params) {
              return new that.$echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [{
                    offset: 1,
                    color: barTopColor[params.dataIndex]
                  },
                    {
                      offset: 0,
                      color: barBottomColor[params.dataIndex]
                    }
                  ]
              );
            },
            // color: function (params) {
            //   console.log(params.dataIndex)
            //   return that.$echarts.graphic.RadialGradient(
            //       0.4, 0.3, 1,
            //       [{
            //         offset: 0,
            //         color: colorList[params.dataIndex]
            //       },
            //         {
            //           offset: 1,
            //           color: colorList[params.dataIndex]
            //         }
            //       ]
            //   );
            // },
          }
        }]
      });
    },
    drawLine3() {
      var that = this;
      var barBottomColor = ["rgba(79, 199, 234, 1)", "rgba(79, 199, 234, 1)", "rgba(79, 199, 234, 1)", 'rgba(228, 109, 62, 1)'];
      var barTopColor = ["rgba(79, 199, 234, 1)", "rgba(79, 199, 234, 1)", "rgba(79, 199, 234, 1)", 'rgba(242, 163, 111, 1)'];
      var data = [[[4, 5, '上海'], [10, 6, '深圳'], [16, 9, '大连'], [20, 16, '北京']]];
      let myChart = this.$echarts.init(this.$refs.myChart3)
      myChart.setOption({
        title: {
          text: '银行开户',
          x: '120',
          y: 'top',
          textStyle: {
            //文字颜色
            color: 'rgba(57, 249, 255, 1)',
            //字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            //字体系列
            fontFamily: 'sans-serif',
            //字体大小
            fontSize: 30
          }
        },
        grid: {
          top: '13%',
          right: '0%',
          left: '0%',
          bottom: '19%'
        },
        xAxis: {
          axisTick: {
            show: false
          },
          min: 0,
          max: 24,
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 3
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            show: false,
            textStyle: {
              fontSize: 18,
              color: "rgba(255, 255, 255, 1)" //X轴文字颜色
            },
          },
          nameTextStyle: {
            fontSize: 30,
            padding: [70, 0, 0, -90]    // 四个数字分别为上右下左与原位置距离
          }
        },
        yAxis: {
          axisTick: {
            show: false
          },
          min: 0,
          max: 24,
          minInterval: 6,
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            show: true,
            scale: false,
            color: 'rgba(155, 173, 255, 1)',
            formatter: function (val) {
              return val + '小时';
            },
            textStyle: {
              fontSize: 24
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 3
            }
          },
          nameTextStyle: {
            fontSize: 30,
            padding: [0, 0, 0, 70]    // 四个数字分别为上右下左与原位置距离
          },
          scale: true
        },
        series: [{
          data: data[0],
          type: 'scatter',
          symbolSize: function () {
            return [60, 60];
          },
          label: {
            show: false,
            normal: {
              show: true,
              formatter: function (param) {
                return param.data[2];
              },
              fontSize:20,
              position: 'inside'
            }
          },
          itemStyle: {
            show: true,
            shadowBlur: 100,
            shadowOffsetY: 5,
            color: function (params) {
              return new that.$echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [{
                    offset: 1,
                    color: barTopColor[params.dataIndex]
                  },
                    {
                      offset: 0,
                      color: barBottomColor[params.dataIndex]
                    }
                  ]
              );
            },
            // color: function (params) {
            //   console.log(params.dataIndex)
            //   return that.$echarts.graphic.RadialGradient(
            //       0.4, 0.3, 1,
            //       [{
            //         offset: 0,
            //         color: colorList[params.dataIndex]
            //       },
            //         {
            //           offset: 1,
            //           color: colorList[params.dataIndex]
            //         }
            //       ]
            //   );
            // },
          }
        }]
      });
    },

  },
  mounted() {
    this.drawLine();
    this.drawLine2();
    this.drawLine3();
  },
}
</script>

<style lang="scss" scoped>
.paimingk {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
}

.biaodan {
  height: 300px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: column;
  margin-right: 45px;

  p {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #9BADFF;
    line-height: 35px;
  }
}
</style>
